const eventsData = [
    {
      name: "Number of Events",
      url: "counts"
    },
    {
      name: "Total Event Hours",
      url: "hours"
    },
    {
      name: "Top Events",
      url: "top"
    }
  ]

eventsData.sort((a, b) => a.name.localeCompare(b.name))

  export default eventsData;